// src/components/Loader.js
import React from 'react';
import '../styles/Loader.css';

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader-content">
        <div className="spinner"></div>
        <h2 className="loader-text">Loading, please wait...</h2>
      </div>
    </div>
  );
};

export default Loader;
